
import { defineComponent, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "article-page",
  components: {},
  setup() {
    const pengumumanType = {
      UMUM: "Umum",
      PEPERIKSAAN: "Peperiksaan",
      PERKHIDMATAN: "Perkhidmatan",
    };
    const route = useRoute();

    const details = reactive({
      jenis: "",
      tajuk: "",
      kandungan: "",
      lampiran_meta: [],
    });

    const base64ToString = (payload) => {
      return atob(payload);
    };

    onMounted(() => {
      const obj = JSON.parse(base64ToString(route.params.id));
      details.jenis = obj.jenis;
      details.tajuk = obj.tajuk;
      details.kandungan = obj.kandungan;
      details.lampiran_meta = obj.lampiran_meta;
    });

    const getTypeText = (type) => {
      switch (type) {
        case "UM":
          return pengumumanType.UMUM;
        case "PP":
          return pengumumanType.PEPERIKSAAN;
        case "PK":
          return pengumumanType.PERKHIDMATAN;
        default:
          return pengumumanType.UMUM;
      }
    };

    return { base64ToString, details, getTypeText };
  },
});
